import type { StoreDispatch } from '@app/store/dispatch'
import type { ThunkAction } from '@app/store/thunk'
import { createThunk } from '@app/store/thunk'

import type { Context } from './Context'

export const getContext = () =>
  createThunk((_dispatch, _getState, context) => {
    return context
  })

export const getRootContext = () =>
  createThunk((_dispatch, _getState, context) => {
    return context.getRootContext()
  })

export function withIsolatedContext<R = unknown>(action: ThunkAction<R>) {
  return createThunk((dispatch, _getState, context) => {
    const ctx = context.getRootContext().getChildContext()
    return dispatch(createDispatch(ctx))(action)
  })
}

export function withChildContext<R = unknown>(action: ThunkAction<R>) {
  return createThunk((dispatch, _getState, context) => {
    return dispatch(createDispatch(context.getChildContext()))(action)
  })
}

export function withRootContext<R = unknown>(action: ThunkAction<R>) {
  return createThunk((dispatch, _getState, context) => {
    if (!context.getParentContext()) return dispatch(action)
    return dispatch(createDispatch(context.getRootContext()))(action)
  })
}

function createDispatch(ctx: Context) {
  return createThunk((dispatch, getState) => {
    const pdispatch: StoreDispatch = (action: any) => (typeof action === 'function' ? action(pdispatch, getState, ctx) : dispatch(action))
    return pdispatch
  })
}
